export const FORCE_LENDER_MAX_BID_TOOLTIP = 'force_lender_max_bid_tooltip'
export const FORCE_SAVED_ASSET_TOOLTIP = 'force_saved_asset_tooltip'

export const RESERVE_TOOLTIP_CONTENT_1 =
  'The Reserve is the minimum price established by the Seller before the auction.'
export const RESERVE_TOOLTIP_CONTENT_2 =
  'A winning bidder can be declared whether or not the Reserve is met.'

export const MATCH_BID_TOOLTIP_CONTENT =
  'Number of bidders who are in line to transact on your property, if you do not complete the Contract Information Form in time.'

export const BID_DEPOSIT_TOOLTIP_CONTENT =
  'If you are the Winning Bidder and fail to perform per the Participation Terms, the full Bid Deposit Amount shall be paid as liquidated damages and not as a penalty. '
